import type { UserJoint } from "@stss/types";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useState } from "react";
import React from "react";

const UserJoints = ({
  label,
  joints,
  activeOverrides,
}: {
  label: string;
  joints: UserJoint[];
  activeOverrides: boolean;
}) => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(true);

  const getLabel = () => {
    if (joints.length > 0) {
      return (
        <p className="text-blue-500" onClick={() => setCollapsed(!collapsed)}>
          <span className="cursor-pointer">{label + " (" + joints.length + ")"}</span>
        </p>
      );
    } else {
      return <p className="cursor-pointer text-gray-700">{"No " + label.toLowerCase()}</p>;
    }
  };

  return (
    <div
      className="mt-2 rounded-md border border-gray-700 p-0 p-1 text-sm dark:border-white"
      onClick={(event) => event.stopPropagation()}>
      {getLabel()}
      {!collapsed && joints.length && (
        <table className={classNames("mt-1 w-full text-left text-sm", collapsed && "h-0")}>
          <thead>
            <tr className="border-b border-gray-700 dark:border-white">
              <th className="text-left font-normal">Name</th>
              <th className="text-left font-normal">Status</th>
              <th className="text-center font-normal">In progress</th>
              <th className="text-center text-xs font-normal">
                Completed <br />
                sessions
              </th>
              {activeOverrides && <th className="text-right font-normal">Override</th>}
            </tr>
          </thead>
          <tbody>
            {joints.map((joint: UserJoint) => (
              <tr
                key={joint.id}
                title={joint.description}
                className={classNames(
                  "border-b border-b-transparent font-normal hover:border-gray-700 hover:dark:border-white",
                  joint.current ? "text-green-500" : ""
                )}>
                <th className="font-normal">{joint.display_name}</th>
                <th className="font-normal">{joint.status && <span>{joint.statusDisplayName}</span>}</th>
                <th className="text-center font-normal">
                  {joint.session_in_progress ? (
                    <span className="text-green-500">yes</span>
                  ) : (
                    <span className="text-gray-500">no</span>
                  )}
                </th>
                <th className="text-center font-normal">
                  {joint.sessions_completed !== undefined && <span>{joint.sessions_completed}</span>}
                </th>
                {joint.override_id !== undefined && (
                  <th title="Override" className="text-right font-normal">
                    <Link
                      href={"/manual-override/" + joint.override_id}
                      title="View override in a new tab"
                      target="_blank"
                      className="text-sky-500 underline dark:text-sky-600">
                      {joint.override_id}
                    </Link>
                  </th>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserJoints;
